
import MapCommandZoom from './MapCommandZoom';

export default class MapCommandZoomIn extends MapCommandZoom {

    constructor(options) {
        options = options || {};
        options.delta = -1;
        super(options);
        this._name = 'ZOOM_OUT';
    }
}
